import React from "react";
import CategoryHead from "../../../components/categoryhead";
import styled from "styled-components";
import { EDGE_SPACING, EDGE_SPACING_MED } from "./consts";
import { styledMedia } from "../../../components/mediaquery/breakpoints";
import GridOnly from "./grid-only";

const HeadContainer = styled.h2`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 ${EDGE_SPACING}px 0 ${EDGE_SPACING - 20}px;
  margin-top: 43px;
  margin-bottom: 49px;
  ${styledMedia.medium`
    padding: 0 ${EDGE_SPACING_MED}px 0 0;
    margin-top: 32px;
    margin-bottom: 26px;
  `} ${styledMedia.small`
    margin-top: 18px;
    margin-bottom: 22px;
  `};
`;

/**
 * Book grid with basic header title
 */
function BookGrid({
  BookObject,
  onHeaderClick,
  headerLabel,
  isbns,
  tryLoadMore,
  backArrow,
  actionLink = null
}) {
  return (
    <div>
      <HeadContainer>
        <CategoryHead
          onClick={onHeaderClick}
          label={headerLabel}
          caretLeft={!!onHeaderClick}
          backArrow={backArrow}
        />
        {actionLink}
      </HeadContainer>

      <GridOnly
        isbns={isbns}
        label={headerLabel}
        tryLoadMore={tryLoadMore}
        BookObject={BookObject}
      />
    </div>
  );
}

export default BookGrid;
